export enum BookingReviewManagementModeEnum {
    Unset = 0,
    Create = 1,
    Update = 2
}
